import { render } from "./chronologyReports.vue?vue&type=template&id=a772f24e&scoped=true"
import script from "./chronologyReports.vue?vue&type=script&lang=js"
export * from "./chronologyReports.vue?vue&type=script&lang=js"

import "./chronologyReports.vue?vue&type=style&index=0&id=a772f24e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a772f24e"]])

export default __exports__